import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="font-heading text-6xl font-extrabold text-primary-200 md:text-8xl">
        404
      </span>
      <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面走丢了
      </h2>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移除，不妨回到首页，继续发现更多精彩影视内容。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          搜索影视
        </Link>
      </div>
    </div>
  );
}